// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-edit-mode .link{display:inline-block;cursor:pointer}.nav-edit-mode .link.is-active{color:#fff;font-weight:bold;opacity:1 !important}.nav-edit-mode .link.is-active:after{content:\"*\"}", ""]);
// Exports
module.exports = exports;
